import React from 'react';

import { LiliTooltip, LiliToolTipColor, TooltipPosition } from '../../../DesignSystem/LiliTooltip/LiliTooltip';
import { ReactComponent as IconToolTipQuestion } from '../../../assets/icons/svg/shared/ic-shared-help-icon.svg';

interface ToolTipSectionViewProps {
  svgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const ToolTipSectionView: React.FC<ToolTipSectionViewProps> = ({ svgComponent: SvgComponent }) => (
  <div>
    <LiliTooltip
      targetId='tooltip-changephone-flow'
      position={TooltipPosition.TOP_START}
      color={LiliToolTipColor.White}
      description=''
      customContent={(
        <div className='p-4'>
          {' '}
          <SvgComponent />
          {' '}
        </div>
)}
    />
    <div>
      <IconToolTipQuestion
        data-tooltip-id='tooltip-changephone-flow'
        data-tooltip-position-strategy='fixed'
        className='ml-[4px] w-[16px] h-[16px]  stroke-bw07'
      />
    </div>
  </div>
);
